<div *ngIf="inModal" class="modal-header">
    <div class="ml-3 mt-3"><strong>Information by various teams</strong></div>
        <button type="button" (click)="close()" class="btn-close" aria-label="Close"></button>

</div>
<div class="accordion">
    <div class='container mb-3 scrollable'>
        <div ngbAccordion>
            <ng-container *ngFor="let step of steps; let index = index; let first = first;">
                <ng-container>
                    <div ngbAccordionItem  *eosViewTeamInfo="step.role" id="panel-{{index}}">
                    
                        <ng-template ngbAccordionHeader let-opened="opened">
                            <div class="d-flex align-items-center">
                                <button class="btn container-fluid d-flex" ngbPanelToggle>
                                    <div *ngIf="opened">
                                        <img title="Click to collapse" class="resize" src="design/images/minus.png">
                                    </div>
                                    <div *ngIf="!opened">
                                        <img title="Click to expand" class="resize" src="design/images/plus.png">
                                    </div>
                                    <div class="mx-2"><b>{{step.label}}</b></div>
                                    <div *ngIf="model[step.teamInfoprop]?.submittedStatus === 'Completed'"
                                        class="ml-auto px-4 py-1 status-badge completed">Submitted
                                        on: {{model[step.teamInfoprop]?.submittedDate|date:'short'}}</div>
                                    <div *ngIf="model[step.teamInfoprop]?.submittedStatus !== 'Completed'"
                                        class="ml-auto px-4 py-1 status-badge not-started" [ngClass]="{'inprogress': model[step.teamInfoprop]?.submittedStatus === 'In progress','not-started': model[step.teamInfoprop]?.submittedStatus === null }">
                                        {{model[step.teamInfoprop]?.submittedStatus ?
                                        model[step.teamInfoprop]?.submittedStatus :
                                        "Not started" }}
                                    </div> 
                                </button>
                            </div>
                        </ng-template>
                        <ng-template ngbAccordionBody>
                            <form [formGroup]="formArray">
                                <li class="list-group-item" *ngFor="let item of options let i=index;">
                                    <input type="radio" (click)="OnCheck(index,item.id)"
                                        formControlName="{{controlArray[index]}}" [value]="item.id" />
                                    {{item.displayText}}
                                </li>
                                <div *ngIf="step.showComment">
                                    <label for="{{index}}" class="col-md-12 mb-3 mt-3 pl-0">Comment</label>
                                    <textarea id="{{index}}" style="height:100px;"
                                        class="col-md-12 mb-3 mt-2 form-control form-control-sm"
                                        formControlName="{{controlArrayComment[index]}}"></textarea>
                                </div>
                            </form>
                            <button class="btn btn-outline-primary me-2 mt-3" eosDebounce (debounceClick)="save(index,false)"
                                *ngIf="(model[step.role]?.submittedStatus !== 'Completed' && !readOnly && !step.hideSaveAndSubmit)" [disabled]="!step.enableSaveAndSubmit">
                                Save
                            </button>
                            <button eosDebounce class="btn btn-secondary me-2 mt-3" (debounceClick)="save(index,true)"
                                *ngIf="(model[step.role]?.submittedStatus !== 'Completed' && !readOnly && !step.hideSaveAndSubmit)" [disabled]="!step.enableSaveAndSubmit">
                                Submit
                            </button>
                        </ng-template>
                    
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>